// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__FxYmk","header":"ReportDetails_header__1zXLA","title":"ReportDetails_title__CPoKG","left":"ReportDetails_left__7sTge"};